(function($) {


  $(document).ready(function() {
    collection.init();
  });


  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }




  var collection = {
    init: function() {


      /* Collection Filter */
      this.initCollectionFilter();


    /* Collection Sorting */
      this.initCollectionSorting();


    },




    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {


        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();


    },


    /* Hide Dropdown */
    initToggle: function(){


    },


    /* --------------------------------------------------------- */
    /* Categories Fillter */


    filterCategories: function() {


    },


    fillterTagEvents: function() {


      // Metafield filters (shape/stone/fiber/weight) — stored in 'mf' param, triggers
      // full AJAX reload so all pages of the collection are evaluated, not just DOM-visible cards.
      $('body').delegate('.filter-shape a:not(".clear"), .filter-stone a:not(".clear"), .filter-fiber a:not(".clear"), .filter-weight a:not(".clear")', 'click', function(e) {
        $(this).toggleClass('active');
        var tagName = $(this).prev().val();
        if (!tagName) { e.preventDefault(); return; }


        var currentMf = Shopify.queryParams.mf
          ? Shopify.queryParams.mf.split('+')
          : [];
        var pos = currentMf.indexOf(tagName);
        if (pos >= 0) {
          currentMf.splice(pos, 1);
        } else {
          currentMf.push(tagName);
        }
        if (currentMf.length) {
          Shopify.queryParams.mf = currentMf.join('+');
        } else {
          delete Shopify.queryParams.mf;
        }


        collection.filterAjaxClick();
        e.preventDefault();
      });


      // Color swatches — stored in 'colors' param, triggers full AJAX reload so all
      // pages of the collection are evaluated, not just DOM-visible cards.
      $('body').delegate('.filter-color a:not(".clear"), .filter-color label', 'click', function(e) {
        $(this).toggleClass('active');
        var tagName = $(this).prev().val();
        if (!tagName) { e.preventDefault(); return; }


        var currentColors = Shopify.queryParams.colors
          ? Shopify.queryParams.colors.split('+')
          : [];
        var pos = currentColors.indexOf(tagName);
        if (pos >= 0) {
          currentColors.splice(pos, 1);
        } else {
          currentColors.push(tagName);
        }
        if (currentColors.length) {
          Shopify.queryParams.colors = currentColors.join('+');
        } else {
          delete Shopify.queryParams.colors;
        }


        collection.filterAjaxClick();
        e.preventDefault();
      });


      $( "body" ).delegate( '.filter-tag:not(.filter-color):not(.filter-shape):not(.filter-stone):not(.filter-fiber):not(.filter-weight) a:not(".clear"), .filter-tag:not(.filter-color):not(.filter-shape):not(.filter-stone):not(.filter-fiber):not(.filter-weight) label', 'click',function(e) {
         $(this).toggleClass('active');
        var currentTags = [];


        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }


        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }


        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },


    filterMapClearAll: function() {
      //clear all selection
        $("body").delegate( '.refined-widgets a.clear-all','click', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.colors;
            delete Shopify.queryParams.mf;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
            $('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');


        });


         $("body").delegate( '.filter-block .clear', 'click', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });


    },


//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
   
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {    
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    },
   


    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },


    filterMapEvents: function() {
        collection.fillterTagEvents();
    },


    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag:not(.filter-color) input:checked").attr("checked", false);


        // Re-mark active color swatches from queryParams.colors
        $('.filter-color .color-swatch').removeClass('active');
        $('.filter-color input[type="checkbox"]').prop('checked', false);
        if (Shopify.queryParams.colors) {
          var activeColors = Shopify.queryParams.colors.split('+');
          activeColors.forEach(function(c) {
            var $inp = $('.filter-color input[value="' + c + '"]');
            $inp.prop('checked', true);
            $inp.next('.color-swatch').addClass('active');
          });
        }


        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },


    filterMapData: function(data, skipApplyFilters) {


        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");


        // Hide before DOM swap to prevent flash of unfiltered content
        productList.css('visibility', 'hidden');


        currentList.replaceWith(productList);


        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };


        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
        quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
          jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });


        // Skip applyFilters here when fetchAllAndFilter will handle it after all pages load
        if (!skipApplyFilters) {
          collection.applyPriceFilter();
          $('.grid-uniform').css('visibility', '');
        }


        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row', function() {
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')});
                $('.loadmore').eq(0).remove();
                loadmore();
                quickView();
                collection.applyPriceFilter();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });
                $('.loading.tshopify-popup').removeClass('active');
              });
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();




        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage });
            return false;
          });
        });


    },


    getSizeConstraints: function() {
      if (!Shopify.queryParams.constraint) return [];
      var pricePattern = new RegExp('^\\d+-\\d+$');
      return Shopify.queryParams.constraint.split('+').filter(function(t) {
        return t && !pricePattern.test(t);
      });
    },


    getColorConstraints: function() {
      if (!Shopify.queryParams.colors) return [];
      return Shopify.queryParams.colors.split('+').filter(Boolean);
    },


    getMfConstraints: function() {
      if (!Shopify.queryParams.mf) return [];
      return Shopify.queryParams.mf.split('+').filter(Boolean);
    },


    applyFilters: function() {
      var sizes = collection.getSizeConstraints();
      var colors = collection.getColorConstraints();
      var mfs = collection.getMfConstraints();
      var range = collection.getPriceConstraint();
      var visibleCount = 0;


      $('.engoj_grid_parent').each(function() {
        var $card = $(this);
        var $wrapper = $card.closest('.js_size_prod, .trans-product');
        if ($wrapper.length === 0) $wrapper = $card.parent();


        var passesSize = true;
        if (sizes.length) {
          var cardSizes = ($card.attr('data-sizes') || '').split(' ').filter(Boolean);
          passesSize = sizes.some(function(s) { return cardSizes.indexOf(s) >= 0; });
        }


        var passesColor = true;
        if (colors.length) {
          var cardColors = ($card.attr('data-colors') || '').split(' ').filter(Boolean);
          passesColor = colors.some(function(c) { return cardColors.indexOf(c) >= 0; });
        }


        var passesMf = true;
        if (mfs.length) {
          var cardMf = [
            ($card.attr('data-shape') || ''),
            ($card.attr('data-stone') || ''),
            ($card.attr('data-fiber') || ''),
            ($card.attr('data-weight') || '')
          ].join(' ').split(' ').filter(Boolean);
          passesMf = mfs.some(function(m) { return cardMf.indexOf(m) >= 0; });
        }


        var passesPrice = true;
        if (range) {
          var price = parseInt($card.attr('data-price'), 10);
          passesPrice = !isNaN(price) && price >= range.min && price <= range.max;
        }


        if (passesSize && passesColor && passesMf && passesPrice) {
          $wrapper.show();
          visibleCount++;
        } else {
          $wrapper.hide();
        }
      });


      var $noResults = $('#filter-no-results');
      if (!$noResults.length) {
        $('<p id="filter-no-results" class="text-center w-100" style="display:none">No products match the selected filters.</p>')
          .appendTo('.product-grid-view .row');
        $noResults = $('#filter-no-results');
      }
      var hasActiveFilter = sizes.length > 0 || colors.length > 0 || mfs.length > 0 || range !== null;
      $noResults.toggle(hasActiveFilter && visibleCount === 0);
    },


    applySizeFilter: function() { collection.applyFilters(); },


    getPriceConstraint: function() {
      if (!Shopify.queryParams.constraint) return null;
      var parts = Shopify.queryParams.constraint.split('+');
      var pricePattern = new RegExp('^\\d+-\\d+$');
      for (var i = 0; i < parts.length; i++) {
        if (pricePattern.test(parts[i])) {
          var bounds = parts[i].split('-');
          return { min: parseInt(bounds[0], 10), max: parseInt(bounds[1], 10) };
        }
      }
      return null;
    },


    setPriceConstraint: function(min, max) {
      var absMax = parseInt($('#flt_price_slider').attr('data-max'), 10) || 99999;


      // Strip any existing price token (digits-digits) from constraint
      var pricePattern = new RegExp('^\\d+-\\d+$');
      var currentTags = Shopify.queryParams.constraint
        ? Shopify.queryParams.constraint.split('+').filter(function(t) { return !pricePattern.test(t); })
        : [];


      // Add price token unless user has selected the full range (0 to absMax)
      if (min !== 0 || max !== absMax) {
        currentTags.push(min + '-' + max);
      }


      if (currentTags.length) {
        Shopify.queryParams.constraint = currentTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
    },


    applyPriceFilter: function() { collection.applyFilters(); },


    initPriceSlider: function() {
      var $slider = $('#flt_price_slider');
      if (!$slider.length) return;


      var absMin = 0;
      var absMax = parseInt($slider.attr('data-max'), 10);


      var $inputMin = $('#price-input-min');
      var $inputMax = $('#price-input-max');


      // Restore input values from URL if a price constraint already exists
      var existing = collection.getPriceConstraint();
      if (existing) {
        $inputMin.val(existing.min);
        $inputMax.val(existing.max);
      }


      function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }


      function doApply() {
        var rawMin = parseInt($inputMin.val(), 10);
        var rawMax = parseInt($inputMax.val(), 10);
        var vMin = isNaN(rawMin) ? absMin : clamp(rawMin, absMin, absMax);
        var vMax = isNaN(rawMax) ? absMax : clamp(rawMax, absMin, absMax);
        if (vMin > vMax) { var tmp = vMin; vMin = vMax; vMax = tmp; }
        $inputMin.val(vMin);
        $inputMax.val(vMax);
        collection.setPriceConstraint(vMin, vMax);
        collection.applyPriceFilter();
        collection.filterAjaxClick();
      }


      // Apply only on button click — no auto-fire on typing
      $('#price-apply-btn').on('click', function() {
        doApply();
      });


      // Also allow pressing Enter in either input
      $inputMin.add($inputMax).on('keydown', function(e) {
        if (e.which === 13) { doApply(); }
      });


    },


    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {


        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },


    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },


    // When a client-side-only filter (colors, mf) is active the server returns the
    // full unfiltered collection page-by-page. This function follows every Load More
    // page link sequentially, appending all product cards to the DOM while the grid
    // stays hidden, then runs applyFilters() once and reveals only matching products.
    fetchAllAndFilter: function(firstPageData) {
      var $grid = $('.product-grid-view .row');
      var $gridUniform = $('.grid-uniform');


      // Keep grid hidden throughout — no flicker during multi-page fetch
      $gridUniform.css('visibility', 'hidden');


      // Remove the Load More button — we're loading everything ourselves
      $('.loadmore').remove();


      // Find the next-page URL from the first page's Load More button
      var $lmBtn = $(firstPageData).find('.loadmore a');
      var nextUrl = $lmBtn.length ? $lmBtn.attr('href') : null;


      function fetchNext(url) {
        if (!url || url === '#') {
          // All pages in DOM — filter, then reveal in one paint
          collection.applyFilters();
          $gridUniform.css('visibility', '');
          hidePopup('.loading');
          hidePopup('.filter-to-left , .js-bg');
          return;
        }
        $.get(url, function(pageData) {
          // Append cards off-screen (grid is still hidden)
          $(pageData).find('.product-grid-view .row').children().not('.loadmore').each(function() {
            $grid.append($(this));
          });
          var $next = $(pageData).find('.loadmore a');
          var nextPage = $next.length ? $next.attr('href') : null;
          fetchNext(nextPage && nextPage !== '#' ? nextPage : null);
        });
      }


      fetchNext(nextUrl && nextUrl !== '#' ? nextUrl : null);
    },


    filterGetContent: function(newurl) {
      var needsAllPages = !!(Shopify.queryParams.mf || Shopify.queryParams.colors);


      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },


        success: function(data) {
          if (needsAllPages) {
            // Pass skipApplyFilters=true — fetchAllAndFilter will apply filters
            // and reveal the grid only after all pages are loaded.
            collection.filterMapData(data, true);
            collection.filterMapClear();
            collection.fetchAllAndFilter(data);
          } else {
            collection.filterMapData(data);
            collection.filterMapClear();
            hidePopup('.loading');
            hidePopup('.filter-to-left , .js-bg');
          }
        },


        error: function(xhr, text) {
          hidePopup('.loading');
          hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }


      });
    },






    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();


        // Strip client-side-only params (colors, mf) immediately on page load
        // so a reload never re-applies stale filter state from the URL.
        if (Shopify.queryParams.colors || Shopify.queryParams.mf) {
          delete Shopify.queryParams.colors;
          delete Shopify.queryParams.mf;
          var initQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
          var initUrl = location.pathname + (initQuery ? '?' + initQuery : '');
          collection.fillterClick = true;
          History.replaceState({ param: Shopify.queryParams }, initUrl, initUrl);
        }


        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
        collection.initPriceSlider();
        collection.applyFilters();
      }
    },


    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();    
        if (!$(this).parent().hasClass("active")) {  
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();    
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();  
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  


      });
    },


    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {


    },




    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {


    },


    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {


    },


  }


})(jQuery);

